<template>
    <div class="mycontent">
        <el-button icon="el-icon-d-arrow-left" type="info" plain @click="$router.go(-1)" size="small">{{ $t('m.back') }}
        </el-button>
        <h2>创建接口代理</h2>

        <common ref="apiAdd"></common>

        <el-button @click="save" type="primary" plain style="margin:10px 0">{{ $t('m.save') }}</el-button>

    </div>
</template>

<script>
    import common from '@/components/agent/common'

    export default {
        data() {
            return {}
        },
        components: {common},
        methods: {

            save() {
                const detail = this.$refs.apiAdd.detail;
                let p = {
                    name: detail.name,
                    path: 'proxy/'+detail.path,
                    proxyPath: detail.proxyPath,
                    groupId: detail.groupId,
                    previlege: detail.previlege,
                    params: JSON.stringify(detail.params),
                };
                console.log(p);
                if (p.name == null|| p.path == null|| p.proxyPath == null || p.groupId == null) {
                    this.$message.error("必填项未填");
                    return
                }

                this.axios.post("/agentConfig/add", p,
                    {headers: {'Content-Type': 'application/json'}}
                ).then((response) => {
                    if (response.data.success) {
                        this.$message.success(response.data.msg);
                        this.$router.push("/agent")
                    } else {
                        this.$message.error(response.data.msg)
                    }

                }).catch((error) => {
                    this.$message.error("failed")
                })
            }
        },
        created() {

        }
    }
</script>

<style scoped>


</style>
